import React, { useEffect, useState } from "react";
import ReactPlayer from "react-player";
import { IconText, Image } from "@wac-ui-dashboard/wac_component_library";
import Style from "./player.module.scss";
import InputRange from "react-input-range";
const Player = ({
  typeData,
  dataList,
  title,
  dataFileIndex,
  setDataFileIndex,
  handleClose,
  isShortVideo,
}) => {
  const [isFullScreen, setIsFullScreen] = useState(false);
  const [currentUrl, setCurrentUrl] = useState("");
  const [muted, setMuted] = useState(false);
  const [volume, setVolume] = useState(1);
  const [seeking, setSeeking] = useState(false);
  const [played, setPlayed] = useState(0);
  const [playedSeekChange, setPlayedSeekChange] = useState(0);
  const [isPlaying, setIsPlaying] = useState(true);
  const [duration, setDuration] = useState(0);
  const playerRef = React.createRef(null);
  const minutes = Math.floor(duration / 60);
  const remainingSeconds = duration % 60;
  const totalHour = Math.floor(duration / 3600);
  const [currentTime, setCurrentTime] = useState(0);
  const [hours, setHours] = useState(0);
  const [nextButtonDisable, setNextButtonDisable] = useState(false);
  const [preButtonDisable, setPreButtonDisable] = useState(false);

  const dataListAudioResponse = dataList?.filter(
    (res) => res.audio_response !== ""
  );
  const dataListVideoResponse = dataList?.filter(
    (res) => res.video_response !== ""
  );

  const handlePrevious = () => {
    setNextButtonDisable(false);
    if (dataFileIndex > 0) {
      setDataFileIndex((prev) => prev - 1);
    }
    if (dataFileIndex === 1) {
      setPreButtonDisable(true);
    }
  };

  const handleNext = () => {
    setPreButtonDisable(false);
    if (dataFileIndex <= dataListAudioResponse.length - 1) {
      setDataFileIndex((prev) => prev + 1);
    }

    if (dataFileIndex === dataListAudioResponse.length - 2) {
      setNextButtonDisable(true);
    }
  };

  useEffect(() => {
    let url =
      typeData === "audio"
        ? dataListAudioResponse[dataFileIndex]?.audio_response ||
          dataListAudioResponse[dataFileIndex]?.audio
        : dataListVideoResponse[dataFileIndex]?.video_response ||
          dataListVideoResponse[dataFileIndex]?.video;
    setCurrentUrl(url);
  }, [dataFileIndex]);

  useEffect(() => {
    if (playerRef) {
      playerRef.current.volume = volume / 100;
      playerRef.current.muted = muted;
    }
  }, [volume, playerRef, muted]);

  const handleVolumeChange = (e) => {
    setVolume(parseFloat(e.target.value));
  };
  const handleMute = (e) => {
    playerRef.current.muted = !playerRef.current.muted;
    setVolume(playerRef.current.muted ? 0 : 1);
    setMuted((m) => !m);
  };

  const handleSeekMouseDown = () => {
    setSeeking(true);
  };

  const handleSeekChange = (e) => {
    // setPlayed(parseFloat(e.target.value)); -> here
    const time = parseFloat(e.target.value);
    setCurrentTime(time);
    if (playerRef.current) {
      playerRef.current.seekTo(time);
    }
  };

  const handleSeekMouseUp = () => {
    setSeeking(false);
    playerRef.current.seekTo(currentTime);
  };

  // const handleProgress = (progress) => {
  //   if (!seeking) {
  //     setPlayed(progress.played);
  //   }
  // };
  const handleProgress = (state) => {
    setCurrentTime(state.playedSeconds);
    parseInt(duration) === parseInt(currentTime) && setIsPlaying(false);
  };

  const formatTime = (timeInSeconds) => {
    const minutes = Math.floor(timeInSeconds / 60);
    if (minutes > 59) {
      const hour = Math.floor(timeInSeconds / 3600);
      setHours(hour);
    }
    const seconds = Math.floor(timeInSeconds % 60);
    return `${hours}:${String(minutes).padStart(2, 0)}:${String(
      seconds
    ).padStart(2, 0)}`;
  };

  const handlePlayPause = () => {
    if (parseInt(duration) === parseInt(currentTime)) {
      setCurrentTime(0);
      setIsPlaying(true);
    } else {
      setIsPlaying(!isPlaying);
    }
  };

  const handleDuration = (duration) => {
    setDuration(duration);
  };

  let startY = 0;

  // Function to update the volume
  const updateVolume = (deltaY) => {
    const step = 0.02; // Change this value to control the volume sensitivity
    const newVolume = Math.max(0, Math.min(volume + step * -deltaY, 1));
    setVolume(newVolume);
  };

  // Handle touch start event
  const handleTouchStart = (event) => {
    startY = event.touches[0].clientY;
  };

  // Handle touch move event
  const handleTouchMove = (event) => {
    const currentY = event.touches[0].clientY;
    const deltaY = startY - currentY;
    startY = currentY;
    updateVolume(deltaY);
    alert(volume, "hoi");
  };

  return typeData === "audio" ? (
    <div className={Style.audio_root}>
      <div className={Style.player_outer_wraper}>
        <div className="row pro-items-center">
          <div className="col-4">
            <div
              className={`pro-d-flex pro-items-center ${Style.audio_title_wrap}`}
            >
              {true && (
                <div className={`${Style.img_wrap}`}>
                  <Image
                    height={45}
                    width={45}
                    alt={`image`}
                    src={`https://picsum.photos/200/300`}
                  />
                </div>
              )}

              <p className={`pro-mb-0 pro-fw-medium ${Style.audio_title}`}>
                {dataListAudioResponse[dataFileIndex]?.title}
                {/* {dataListVideoResponse[dataFileIndex]?.title} */}
              </p>
            </div>
          </div>
          <div className="col-4">
            <div
              className={`${Style.player_main_wrap} pro-d-flex pro-flex-column pro-items-center pro-text-center pro-w-100 pro-gap-2`}
            >
              <div className="pro-d-flex pro-items-center pro-gap-3">
                <button
                  id="play-icon"
                  className={`pro-btn ${Style.btn_controls} ${Style.btn_prev}`}
                  onClick={handlePrevious}
                  disabled={preButtonDisable}
                >
                  {/* <span className={`material-symbols-outlined ${Style.icon_filled} ${Style.icon}`}>skip_previous</span> */}
                  <svg
                    width="16"
                    height="17"
                    viewBox="0 0 16 17"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M11.8242 15.6692L3.75489 9.65646C3.75472 9.65634 3.75456 9.65621 3.75439 9.65609C3.71968 9.63002 3.69447 9.6051 3.64791 9.55906C3.63009 9.54146 3.60916 9.52076 3.58337 9.49572L2.73511 8.67232V9.85449V15.792C2.73511 16.0129 2.48977 16.3337 1.99255 16.3337C1.49534 16.3337 1.25 16.0129 1.25 15.792V1.20866C1.25 0.987732 1.49534 0.666992 1.99255 0.666992C2.48977 0.666992 2.73511 0.987732 2.73511 1.20866V7.14616V8.32833L3.58336 7.50493C3.60976 7.47931 3.63116 7.45813 3.64942 7.44005C3.69495 7.39498 3.72099 7.36921 3.75628 7.34211L11.8242 1.33043L11.825 1.32982C12.4204 0.884273 13.2608 0.77031 14.0174 1.05381C14.7687 1.3364 15.1606 1.90405 15.1606 2.48678V14.5139C15.1606 15.0967 14.7686 15.6642 14.0177 15.9457L14.0175 15.9458C13.7405 16.0497 13.4509 16.1014 13.1668 16.1014C12.6745 16.1014 12.2009 15.9507 11.8247 15.6696L11.8242 15.6692Z"
                      fill="#6B7280"
                      stroke="#6B7280"
                    />
                  </svg>
                </button>
                <button
                  onClick={handlePlayPause}
                  className={`pro-btn ${Style.btn_controls} ${Style.btn_play}`}
                >
                  {/* <span className={`material-symbols-outlined ${Style.icon_play} ${Style.icon}`}>
                  {isPlaying ? "pause_circle" : "play_circle"}
                </span> */}
                  {isPlaying &&
                  !(parseInt(duration) === parseInt(currentTime)) ? (
                    <svg
                      width="36"
                      height="36"
                      viewBox="0 0 36 36"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        className={Style.play_fill}
                        d="M0 18C0 8.05887 8.05887 0 18 0V0C27.9411 0 36 8.05887 36 18V18C36 27.9411 27.9411 36 18 36V36C8.05887 36 0 27.9411 0 18V18Z"
                      />
                      <rect
                        x="11.4981"
                        y="10.155"
                        width="4.50379"
                        height="15.7668"
                        fill="white"
                      />
                      <rect
                        x="19.9981"
                        y="10.0781"
                        width="4.50379"
                        height="15.7668"
                        fill="white"
                      />
                    </svg>
                  ) : (
                    <svg
                      width="36"
                      height="36"
                      viewBox="0 0 36 36"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        className={Style.play_fill}
                        d="M0 18C0 8.05887 8.05887 0 18 0V0C27.9411 0 36 8.05887 36 18V18C36 27.9411 27.9411 36 18 36V36C8.05887 36 0 27.9411 0 18V18Z"
                      />
                      <path
                        d="M25.4806 17.1318C26.1524 17.5157 26.1524 18.4843 25.4806 18.8682L14.4961 25.1451C13.8295 25.526 13 25.0446 13 24.2768L13 11.7232C13 10.9554 13.8295 10.474 14.4961 10.8549L25.4806 17.1318Z"
                        fill="white"
                      />
                    </svg>
                  )}
                </button>
                <button
                  id="play-icon"
                  className={`pro-btn ${Style.btn_controls} ${Style.btn_next}`}
                  onClick={handleNext}
                  disabled={nextButtonDisable}
                >
                  {/* <span className={`material-symbols-outlined ${Style.icon_filled} ${Style.icon}`}>skip_next</span> */}
                  <svg
                    width="15"
                    height="17"
                    viewBox="0 0 15 17"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M13.814 0.833008C13.1582 0.833008 12.628 1.26138 12.628 1.79134V7.25384C12.5604 7.19059 12.4964 7.12447 12.4181 7.06792L4.71624 1.53451C4.0082 1.02563 3.03332 0.905841 2.16873 1.21826C1.30414 1.53163 0.768066 2.20247 0.768066 2.96722V14.0331C0.768066 14.7978 1.30414 15.4677 2.16873 15.7811C2.48657 15.8961 2.81984 15.9536 3.14954 15.9536C3.71526 15.9536 4.26912 15.7868 4.71624 15.4648L12.4181 9.93238C12.4964 9.87584 12.5604 9.80972 12.628 9.74647V15.208C12.628 15.738 13.1582 16.1663 13.814 16.1663C14.4699 16.1663 15 15.738 15 15.208V1.79134C15 1.26138 14.4699 0.833008 13.814 0.833008Z"
                      fill="#6B7280"
                    />
                  </svg>
                </button>
              </div>
              <div className={`${Style.player_control_wrap} mb`}>
                <ReactPlayer
                  ref={playerRef}
                  url={currentUrl}
                  controls
                  width="100%"
                  height="auto"
                  playing={isPlaying}
                  playsinline
                  volume={volume}
                  onProgress={handleProgress}
                  onDuration={handleDuration}
                />
                <div className={Style.input_container}>
                  <span
                    className={`${Style.time_start} ${Style.time} pro-fw-medium`}
                  >
                    {formatTime(currentTime)}
                  </span>

                  <div className={Style.slider_wrapper}>
                    <input
                      type="range"
                      min={0}
                      max={duration}
                      step={0.1}
                      value={currentTime}
                      onChange={handleSeekChange}
                      onMouseDown={handleSeekMouseDown}
                      onMouseUp={handleSeekMouseUp}
                      className={Style.pro_audio_input}
                    />
                    <div className={Style.tracker_wrpper}>
                      <div
                        className={Style.tracker_bar}
                        style={{ width: `${(currentTime / duration) * 100}%` }}
                      ></div>
                    </div>
                  </div>

                  <span
                    className={`${Style.time_end} ${Style.time} pro-fw-medium`}
                  >
                    {formatTime(duration)}
                  </span>
                </div>
              </div>
            </div>
          </div>
          <div className="col-4">
            <div className={`${Style.right} pro-d-flex pro-justify-end`}>
              <div className={Style.volume_containe}>
                {!muted && (
                  <div className={Style.slider_wrapper}>
                    <input
                      type="range"
                      min={0}
                      max={1}
                      step={0.1}
                      value={volume}
                      onChange={handleVolumeChange}
                    />

                    <div className={Style.tracker_wrpper}>
                      <div
                        className={Style.tracker_bar}
                        style={{ width: `${(volume / 1) * 100}%` }}
                      ></div>
                    </div>
                  </div>
                )}

                <button
                  onClick={handleMute}
                  className={`pro-btn ${Style.btn_controls} pro-d-flex pro-items-center`}
                >
                  {muted ? (
                    <svg
                      width="17"
                      height="17"
                      viewBox="0 0 17 17"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M13.019 14.452C12.8862 14.5359 12.7525 14.6146 12.618 14.688C12.4835 14.7613 12.3445 14.8277 12.2011 14.8872C11.9828 14.9878 11.7627 14.9869 11.5408 14.8847C11.3188 14.7825 11.1662 14.6137 11.0829 14.3782C11.0029 14.1731 11.01 13.9724 11.1042 13.776C11.1984 13.5796 11.3397 13.4262 11.5281 13.3157C11.6021 13.284 11.6707 13.2496 11.7341 13.2126C11.7975 13.1757 11.861 13.136 11.9244 13.0937L9.12454 10.5326V12.7754C9.12454 13.2002 8.93032 13.4946 8.54189 13.6587C8.15345 13.8228 7.80902 13.7547 7.5086 13.4543L4.72372 10.6694H2.23866C1.97266 10.6694 1.74818 10.5779 1.5652 10.3949C1.38223 10.212 1.29075 9.98747 1.29075 9.72145V6.27854C1.29075 6.01252 1.38223 5.78803 1.5652 5.60506C1.74818 5.42209 1.97266 5.3306 2.23866 5.3306H3.96739L0.600516 1.93885C0.437794 1.77611 0.357259 1.57336 0.358912 1.3306C0.360578 1.08785 0.44278 0.885107 0.605516 0.722371C0.768266 0.559621 0.971016 0.479079 1.21377 0.480746C1.45652 0.482399 1.65926 0.564601 1.822 0.727351L16.163 15.163C16.3258 15.3258 16.4072 15.5285 16.4072 15.7713C16.4072 16.014 16.3258 16.2168 16.163 16.3795C16.0003 16.5423 15.7967 16.6236 15.5523 16.6236C15.3079 16.6236 15.1043 16.5423 14.9416 16.3795L13.019 14.452ZM15.5127 12.0548L14.2495 10.7817C14.4856 10.3545 14.6627 9.90557 14.7808 9.435C14.8988 8.96444 14.9595 8.47916 14.9629 7.97916C14.9629 6.83302 14.6581 5.78509 14.0487 4.83537C13.4392 3.88564 12.6239 3.173 11.6028 2.69745C11.3878 2.59691 11.2317 2.44097 11.1345 2.22962C11.0373 2.01826 11.0267 1.80343 11.1028 1.58514C11.1895 1.35296 11.3446 1.18659 11.5682 1.08604C11.7917 0.985496 12.018 0.985496 12.2468 1.08604C13.5974 1.69323 14.6779 2.61292 15.4885 3.8451C16.299 5.07729 16.7043 6.45532 16.7043 7.97916C16.7043 8.72857 16.6011 9.44686 16.3947 10.1341C16.1883 10.8213 15.8943 11.4615 15.5127 12.0548ZM12.726 9.25316L10.7912 7.30841V5.36006C10.7912 5.18342 10.8674 5.05359 11.0199 4.97056C11.1724 4.88753 11.3231 4.891 11.4719 4.98097C11.9369 5.29257 12.3002 5.73589 12.5618 6.31091C12.8235 6.88594 12.9543 7.44897 12.9543 8C12.9543 8.21829 12.9352 8.43228 12.8972 8.64198C12.8591 8.85167 12.8021 9.0554 12.726 9.25316ZM9.12454 5.62681L6.7885 3.26585L7.5086 2.54573C7.80902 2.24531 8.15345 2.17715 8.54189 2.34125C8.93032 2.50534 9.12454 2.7998 9.12454 3.22462V5.62681Z"
                        fill="#6B7280"
                      />
                    </svg>
                  ) : (
                    // "muted"
                    <svg
                      width="16"
                      height="14"
                      viewBox="0 0 16 14"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M13.9628 6.97917C13.9628 5.83303 13.6581 4.7851 13.0486 3.83538C12.4392 2.88564 11.6239 2.173 10.6027 1.69746C10.3878 1.59692 10.2317 1.44097 10.1344 1.22962C10.0372 1.01826 10.0267 0.803437 10.1027 0.585145C10.1894 0.352965 10.3445 0.186597 10.5681 0.0860416C10.7917 -0.0145 11.0179 -0.0145 11.2468 0.0860416C12.6006 0.696555 13.682 1.62055 14.4909 2.85802C15.2998 4.09549 15.7042 5.46921 15.7042 6.97917C15.7042 8.48913 15.2998 9.86284 14.4909 11.1003C13.682 12.3378 12.6006 13.2618 11.2468 13.8723C11.0179 13.9728 10.7917 13.9728 10.5681 13.8723C10.3445 13.7717 10.1894 13.6054 10.1027 13.3732C10.0267 13.1549 10.0372 12.9401 10.1344 12.7287C10.2317 12.5174 10.3878 12.3614 10.6027 12.2609C11.6239 11.7853 12.4392 11.0727 13.0486 10.123C13.6581 9.17324 13.9628 8.12531 13.9628 6.97917ZM3.72863 9.6694H1.24359C0.977578 9.6694 0.753085 9.57791 0.570113 9.39494C0.38714 9.21197 0.295654 8.98747 0.295654 8.72146V5.27854C0.295654 5.01253 0.38714 4.78804 0.570113 4.60506C0.753085 4.42209 0.977578 4.3306 1.24359 4.3306H3.72863L6.51351 1.54573C6.81394 1.24531 7.15837 1.17715 7.5468 1.34125C7.93524 1.50535 8.12947 1.7998 8.12947 2.22462V11.7754C8.12947 12.2002 7.93524 12.4947 7.5468 12.6587C7.15837 12.8228 6.81394 12.7547 6.51351 12.4543L3.72863 9.6694ZM11.9542 7C11.9542 7.58997 11.8189 8.14787 11.5484 8.67369C11.2779 9.19951 10.9207 9.63406 10.4768 9.97735C10.328 10.0673 10.1773 10.0708 10.0248 9.98777C9.87237 9.90474 9.79613 9.77491 9.79613 9.59827V4.36006C9.79613 4.18342 9.87237 4.05442 10.0248 3.97304C10.1773 3.89168 10.328 3.89599 10.4768 3.98596C10.9207 4.34314 11.2779 4.78729 11.5484 5.3184C11.8189 5.84949 11.9542 6.41003 11.9542 7Z"
                        fill="#6B7280"
                      />
                    </svg>
                  )}
                </button>
              </div>

              <button
                className={`pro-btn ${Style.btn_controls} pro-d-flex pro-items-center`}
                onClick={handleClose}
              >
                <svg
                  width="14"
                  height="14"
                  viewBox="0 0 14 14"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M6.99999 8.4L2.09999 13.3C1.91665 13.4833 1.68332 13.575 1.39999 13.575C1.11665 13.575 0.883321 13.4833 0.699988 13.3C0.516654 13.1167 0.424988 12.8833 0.424988 12.6C0.424988 12.3167 0.516654 12.0833 0.699988 11.9L5.59999 7L0.699988 2.1C0.516654 1.91667 0.424988 1.68333 0.424988 1.4C0.424988 1.11667 0.516654 0.883333 0.699988 0.699999C0.883321 0.516666 1.11665 0.424999 1.39999 0.424999C1.68332 0.424999 1.91665 0.516666 2.09999 0.699999L6.99999 5.6L11.9 0.699999C12.0833 0.516666 12.3167 0.424999 12.6 0.424999C12.8833 0.424999 13.1167 0.516666 13.3 0.699999C13.4833 0.883333 13.575 1.11667 13.575 1.4C13.575 1.68333 13.4833 1.91667 13.3 2.1L8.39999 7L13.3 11.9C13.4833 12.0833 13.575 12.3167 13.575 12.6C13.575 12.8833 13.4833 13.1167 13.3 13.3C13.1167 13.4833 12.8833 13.575 12.6 13.575C12.3167 13.575 12.0833 13.4833 11.9 13.3L6.99999 8.4Z"
                    fill="#6B7280"
                  />
                </svg>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  ) : (
    <div
      className={`${Style.player_control_wrap} ${Style.video_control} ${
        isShortVideo ? Style.short_video : ""
      }`}
    >
      <div style={{ touchAction: "none", width: "100%", height: "0px" }}>
        <ReactPlayer
          ref={playerRef}
          url={currentUrl}
          // controls
          width="100%"
          height="auto"
          playing={isPlaying}
          playsinline
          volume={volume}
          onProgress={handleProgress}
          onDuration={handleDuration}
        />
      </div>
      <span className={Style.video_btn}>
        <button
          onClick={handlePlayPause}
          className={`pro-btn ${Style.btn_play}`}
        >
          {isPlaying && !(parseInt(duration) === parseInt(currentTime)) ? (
            <svg
              width="36"
              height="36"
              viewBox="0 0 36 36"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                className={Style.play_fill}
                d="M0 18C0 8.05887 8.05887 0 18 0V0C27.9411 0 36 8.05887 36 18V18C36 27.9411 27.9411 36 18 36V36C8.05887 36 0 27.9411 0 18V18Z"
              />
              <rect
                x="11.4981"
                y="10.155"
                width="4.50379"
                height="15.7668"
                fill="white"
              />
              <rect
                x="19.9981"
                y="10.0781"
                width="4.50379"
                height="15.7668"
                fill="white"
              />
            </svg>
          ) : (
            <svg
              width="36"
              height="36"
              viewBox="0 0 36 36"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                className={Style.play_fill}
                d="M0 18C0 8.05887 8.05887 0 18 0V0C27.9411 0 36 8.05887 36 18V18C36 27.9411 27.9411 36 18 36V36C8.05887 36 0 27.9411 0 18V18Z"
              />
              <path
                d="M25.4806 17.1318C26.1524 17.5157 26.1524 18.4843 25.4806 18.8682L14.4961 25.1451C13.8295 25.526 13 25.0446 13 24.2768L13 11.7232C13 10.9554 13.8295 10.474 14.4961 10.8549L25.4806 17.1318Z"
                fill="white"
              />
            </svg>
          )}
        </button>
      </span>
      <div
        className={`${Style.input_container} pro-d-flex pro-items-center pro-gap-4`}
      >
        <div className={Style.slider_wrapper}>
          <input
            type="range"
            min={0}
            max={duration}
            step={0.1}
            value={currentTime}
            onMouseDown={handleSeekMouseDown}
            onChange={handleSeekChange}
            onMouseUp={handleSeekMouseUp}
            className={Style.pro_audio_input}
          />

          <div className={Style.tracker_wrpper}>
            <div
              className={Style.tracker_bar}
              style={{ width: `${(currentTime / duration) * 100}%` }}
            ></div>
          </div>
        </div>
        <div className={`pro-d-flex pro-gap-1 ${Style.time_wraper}`}>
          <span className={`${Style.time_start} ${Style.time} pro-fw-medium`}>
            {/* {played} */}
            {formatTime(currentTime)}
          </span>
          /
          <span className={`${Style.time_end} ${Style.time} pro-fw-medium`}>
            {/* {minutes}:{remainingSeconds.toFixed(2)} */}
            {formatTime(duration)}
          </span>
        </div>
      </div>
    </div>
  );
};

export default Player;
